import { useEffect, useState } from "react";
import Header from "../../sharedComponents/Header";
import Footer from "../../sharedComponents/Footer";
import { useNavigate, Outlet, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Loading from "../../sharedComponents/Loading";
import { getStoreBySlug } from "../../utils/ApiCalls";
import { dispatch } from "../../store";
import { General404 } from "../Error404";
import { ToastContainer } from "react-toastify";
import Helmet from "react-helmet";
import { useLocation } from "react-router-dom";
import { DEFAULT_FAVICON, DEFAULT_THEME } from "../../utils/constants";
import { helmetLinks } from "./helmetLink";
import Error500 from "../Error500";

export default function Container() {
  const { slug, index = 1 } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const loading = useSelector((state) => state.loading);
  const storedSlug = useSelector((state) => state.products.slug);
  // const [loading, setLoading] = useState({ state: true, error: false });
  const [storeData, setStoreData] = useState(null);

  useEffect(() => {
    if (loading.error) {
      navigate(0);
      return;
    }
    if (storedSlug !== slug) {
      dispatch.products.changeIndexState("");
    }
    dispatch.products.setSlug(slug);
  }, [pathname]);

  useEffect(() => {
    (async () => {
      try {
        const response = await getStoreBySlug(slug, index);
        setStoreData(response);
      } catch (error) {
        if (error === "Data not found") {
          dispatch.loading.hide();
          return;
        }
        dispatch.loading.error();
      }
    })();
  }, []);

  if (loading.error) return <Error500 />;

  if (!storeData && loading.state) return <Loading />;

  if (!storeData && !loading.state) return <General404 slug={slug} />;

  return (
    <>
      {loading.state && (
        <Loading theme={storeData?.store?.theme || DEFAULT_THEME} />
      )}
      <Helmet link={helmetLinks(storeData?.store?.favicon)}>
        <title>{storeData?.store?.storeName || "Made with Billsclan"}</title>
      </Helmet>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />
      <Header
        store={storeData.store}
        theme={storeData?.store?.theme || DEFAULT_THEME}
      />
      <Outlet
        context={{
          loading: loading,
          categories: storeData.store?.categories,
          storeID: storeData.store?.storeId,
          description: storeData.store?.description,
          currency: storeData.store?.currency,
          storeName: storeData.store?.storeName,
          deliverySetup: storeData.store?.deliverySetups,
          discounts: storeData?.store?.discounts,
          theme: storeData?.store?.theme || DEFAULT_THEME,
          email: storeData?.store?.emailAddress,
        }}
      />
      <Footer
        store={storeData.store}
        theme={storeData?.store?.theme || DEFAULT_THEME}
      />
    </>
  );
}
